module.exports = __webpack_public_path__ + "img/ostruziny-7.5e9fc61f.png";